import {PageLink, PageTitle} from '../../_metronic/layout/core'
import {useParams, useNavigate} from 'react-router-dom'
import {useEffect, useState} from 'react'
import {getPersonById} from '../../coreGlobal/_resquest'
import {IPersonResponse, TPersonTab} from '../../coreGlobal/models/person'
import {SalesForm} from './components/SalesForm'
import {PeopleProvider, usePeople} from '../../coreGlobal/providers/PersonProvider'
import {ContractProvider} from '../sales/core/ContractProvider'
import {BillingProvider} from '../sales/core/billingProvider'
import {ListEvaluation} from './components/ListEvaluation'
import {ListBudget} from './components/ListBudget'
import {ListMedicalRecords} from './components/ListMedicalRecords'
import {ListStatusHistory} from './components/ListStatusHistory'
import {ListMedicalCondition} from './components/ListMedicalCondition'
import {PersonEditModal} from '../../components/Person/PersonEditModal'
import {useClientCart} from '../sales/create/core/clientProvider'
import {ListObservationsHistory} from './components/ListObservationsHistory'
import {
  FranchiseTransferCardProvider,
  useFranchiseTransferCart,
} from './components/FranchiseTransfer/core/FranchiseTransferProvider'
import {RecurrentPaymentProvider} from '../sales/components/modalRecurrentPayment/core/recurrentPaymentProvider'
import Swal from 'sweetalert2'
import {PaymentConfigProvider} from '../../components/PaymentConfig/core/PaymentConfigProvider'
import {ListVoucher} from './components/ListVoucher'
import {LoadingSpinner} from '../../utils/loading/loadingSpinner'
import {ListPersonalData} from './components/ListPersonalData'
import {ListBillings} from './components/ListBillings'
import {HeaderClient} from './components/HeaderClient'
import {ListSalesHistoryMedicalRecord} from './components/ListSalesHistoryMedicalRecord'
import useAuthorization from '../../hooks/useAuthorization'

const peopleBreadcrumbs: Array<PageLink> = [
  {
    title: 'Pessoa',
    path: '/people',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const Show = () => {
  let {id} = useParams()
  const [selectedTab, setSelectedTab] = useState<TPersonTab>('PERSONALDATA')
  const [loadingPage, setLoadingPage] = useState(false)
  const [person, setPerson] = useState<IPersonResponse>()
  const {setShowEditPersonModal, showEditPersonModal} = usePeople()
  const {transferStatus} = useFranchiseTransferCart()
  const navigate = useNavigate()
  const isAuthorizedToViewVoucher = useAuthorization('vouchers.view')

  useEffect(() => {
    const init = async () => {
      setLoadingPage(true)
      try {
        const data = await getPersonById(String(id))
        setPerson(data)
        setLoadingPage(false)
      } catch (error: any) {
        setLoadingPage(false)

        await Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response.data.message,
          showConfirmButton: true,
          allowOutsideClick: false,
        }).then((result) => {
          if (result.isConfirmed) {
            navigate('/people/list')
          }
        })
      }
    }
    init()
  }, [transferStatus])

  return (
    <>
      {loadingPage ? (
        <LoadingSpinner
          title='Carregando'
          style={{
            width: '2rem',
            height: '2rem',
            colorSpinner: '#f1416c',
            colorText: '#f1416c',
          }}
        />
      ) : (
        <>
          <div className='card-body'></div>
          <div className='card mb-5 mb-xl-10'>
            <div className='card-body pt-9 pb-0'>
              {<HeaderClient person={person} />}
              <div className='d-flex overflow-auto h-70px'>
                <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                  <li className='nav-item'>
                    <button
                      className='nav-link active'
                      id='pills-person-data-tab'
                      data-bs-toggle='pill'
                      data-bs-target='#pills-person-data'
                      type='button'
                      role='tab'
                      aria-controls='pills-person-data'
                      aria-selected='true'
                      onClick={() => setSelectedTab('PERSONALDATA')}
                    >
                      Dados pessoais
                    </button>
                  </li>
                  <li className='nav-item'>
                    <button
                      className='nav-link'
                      id='pills-billing-tab'
                      data-bs-toggle='pill'
                      data-bs-target='#pills-billing'
                      type='button'
                      role='tab'
                      aria-controls='pills-billing'
                      aria-selected='true'
                      onClick={() => setSelectedTab('BILLING')}
                    >
                      Dados bancários
                    </button>
                  </li>
                  <li className='nav-item'>
                    <button
                      className='nav-link'
                      id='pills-contracts-tab'
                      data-bs-toggle='pill'
                      data-bs-target='#pills-contracts'
                      type='button'
                      role='tab'
                      aria-controls='pills-contracts'
                      aria-selected='true'
                      onClick={() => setSelectedTab('CONTRACTS')}
                    >
                      Contratos
                    </button>
                  </li>
                  <li className='nav-item'>
                    <button
                      className='nav-link'
                      id='pills-budgets-tab'
                      data-bs-toggle='pill'
                      data-bs-target='#pills-budgets'
                      type='button'
                      role='tab'
                      aria-controls='pills-budgets'
                      aria-selected='true'
                      onClick={() => setSelectedTab('BUDGETS')}
                    >
                      Orçamentos
                    </button>
                  </li>
                  <li className='nav-item'>
                    <button
                      className='nav-link'
                      id='pills-medical-records-tab'
                      data-bs-toggle='pill'
                      data-bs-target='#pills-medical-records'
                      type='button'
                      role='tab'
                      aria-controls='pills-medical-records'
                      aria-selected='true'
                      onClick={() => setSelectedTab('MEDICALRECORDS')}
                    >
                      Prontuário
                    </button>
                  </li>
                  <li className='nav-item'>
                    <button
                      className='nav-link'
                      id='pills-evaluation-tab'
                      data-bs-toggle='pill'
                      data-bs-target='#pills-evaluation'
                      type='button'
                      role='tab'
                      aria-controls='pills-evaluation'
                      aria-selected='true'
                      onClick={() => setSelectedTab('EVALUATION')}
                    >
                      Avaliação
                    </button>
                  </li>
                  <li className='nav-item'>
                    <button
                      className='nav-link'
                      id='pills-schedule-history-tab'
                      data-bs-toggle='pill'
                      data-bs-target='#pills-schedule-history'
                      type='button'
                      role='tab'
                      aria-controls='pills-schedule-history'
                      aria-selected='true'
                      onClick={() => setSelectedTab('SCHEDULEHISTORY')}
                    >
                      Agendamentos
                    </button>
                  </li>
                  <li className='nav-item'>
                    <button
                      className='nav-link'
                      id='pills-medical-condition-tab'
                      data-bs-toggle='pill'
                      data-bs-target='#pills-medical-condition'
                      type='button'
                      role='tab'
                      aria-controls='pills-medical-condition'
                      aria-selected='true'
                      onClick={() => setSelectedTab('MEDICALCONDITION')}
                    >
                      Condição médica
                    </button>
                  </li>
                  <li className='nav-item'>
                    <button
                      className='nav-link'
                      id='pills-statusHistory-tab'
                      data-bs-toggle='pill'
                      data-bs-target='#pills-statusHistory'
                      type='button'
                      role='tab'
                      aria-controls='pills-statusHistory'
                      aria-selected='true'
                      onClick={() => setSelectedTab('STATUSHISTORY')}
                    >
                      Histórico de status
                    </button>
                  </li>
                  <li className='nav-item'>
                    <button
                      className='nav-link'
                      id='pills-observationsHistory-tab'
                      data-bs-toggle='pill'
                      data-bs-target='#pills-observationsHistory'
                      type='button'
                      role='tab'
                      aria-controls='pills-observationsHistory'
                      aria-selected='true'
                      onClick={() => setSelectedTab('OBSERVATIONSHISTORY')}
                    >
                      Anotação Interna
                    </button>
                  </li>
                  {isAuthorizedToViewVoucher && (
                    <li className='nav-item'>
                      <button
                        className='nav-link'
                        id='pills-voucher-tab'
                        data-bs-toggle='pill'
                        data-bs-target='#pills-voucher'
                        type='button'
                        role='tab'
                        aria-controls='pills-voucher'
                        aria-selected='true'
                        onClick={() => setSelectedTab('VOUCHER')}
                      >
                        Voucher
                      </button>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
          <div className='tab-content' id='pills-tabContent'>
            <div
              className='tab-pane fade show active p-4 pt-0 pt-md-4'
              id='pills-person-data'
              role='tabpanel'
              aria-labelledby='pills-person-tab'
            >
              {selectedTab === 'PERSONALDATA' && <ListPersonalData person={person} />}
            </div>
            <div
              className='tab-pane fade p-4 pt-0 pt-md-4'
              id='pills-billing'
              role='tabpanel'
              aria-labelledby='pills-billing-tab'
            >
              {selectedTab === 'BILLING' && <ListBillings person={person} />}
            </div>
            <div
              className='tab-pane fade p-4 pt-0 pt-md-4'
              id='pills-contracts'
              role='tabpanel'
              aria-labelledby='pills-contracts-tab'
            >
              <div className='card mb-5 mb-xl-10'>
                <div className='card-header cursor-pointer'>
                  <div className='card-title m-0'>
                    <h3 className='fw-bolder m-0'>Informações de Contrato</h3>
                  </div>
                </div>
                <div className='card-body py-3'>
                  {selectedTab === 'CONTRACTS' && <SalesForm people={person} />}
                </div>
              </div>
            </div>
            <div
              className='tab-pane fade p-4 pt-0 pt-md-4'
              id='pills-budgets'
              role='tabpanel'
              aria-labelledby='pills-budgets-tab'
            >
              <div className='card mb-5 mb-xl-10'>
                <div className='card-header cursor-pointer'>
                  <div className='card-title m-0'>
                    <h3 className='fw-bolder m-0'>Informações de orçamentos</h3>
                  </div>
                </div>
                <div className='card-body py-3'>
                  <>{selectedTab === 'BUDGETS' && <ListBudget budgets={person?.budgets} />}</>
                </div>
              </div>
            </div>
            <div
              className='tab-pane fade p-4 pt-0 pt-md-4'
              id='pills-medical-records'
              role='tabpanel'
              aria-labelledby='pills-medical-records-tab'
            >
              <div className='card mb-5 mb-xl-10'>
                {selectedTab === 'MEDICALRECORDS' && <ListMedicalRecords peopleId={Number(id)} />}
              </div>
            </div>
            <div
              className='tab-pane fade p-4 pt-0 pt-md-4'
              id='pills-evaluation'
              role='tabpanel'
              aria-labelledby='pills-evaluation-tab'
            >
              <div className='card mb-5 mb-xl-10'>
                <div className='card-header cursor-pointer'>
                  <div className='card-title m-0'>
                    <h3 className='fw-bolder m-0'>Informações de Avaliações</h3>
                  </div>
                </div>
                <div className='card-body py-3'>
                  {selectedTab === 'EVALUATION' && <ListEvaluation clientId={Number(id)} />}
                </div>
              </div>
            </div>
            <div
              className='tab-pane fade p-4 pt-0 pt-md-4'
              id='pills-schedule-history'
              role='tabpanel'
              aria-labelledby='pills-schedule-history-tab'
            >
              <div className='card mb-5 mb-xl-10'>
                {selectedTab === 'SCHEDULEHISTORY' && (
                  <ListSalesHistoryMedicalRecord clientID={Number(id)} />
                )}
              </div>
            </div>
            <div
              className='tab-pane fade p-4 pt-0 pt-md-4'
              id='pills-medical-condition'
              role='tabpanel'
              aria-labelledby='pills-medical-condition-tab'
            >
              <div className='card mb-5 mb-xl-10'>
                <div className='card-header cursor-pointer'>
                  <div className='card-title m-0'>
                    <h3 className='fw-bolder m-0'>Informações da Condição Médica</h3>
                  </div>
                </div>
                <div className='card-body py-3'>
                  {selectedTab === 'MEDICALCONDITION' && (
                    <ListMedicalCondition clientMedicalRestriction={person?.medicalConditions} />
                  )}
                </div>
              </div>
            </div>
            <div
              className='tab-pane fade p-4 pt-0 pt-md-4'
              id='pills-statusHistory'
              role='tabpanel'
              aria-labelledby='pills-statusHistory-tab'
            >
              <div className='card mb-5 mb-xl-10'>
                <div className='card-header cursor-pointer'>
                  <div className='card-title m-0'>
                    <h3 className='fw-bolder m-0'>Informações do Histórico de Status</h3>
                  </div>
                </div>
                <div className='card-body py-3'>
                  {selectedTab === 'STATUSHISTORY' && (
                    <ListStatusHistory clientHistory={person?.clientHistory} />
                  )}
                </div>
              </div>
            </div>
            <div
              className='tab-pane fade p-4 pt-0 pt-md-4'
              id='pills-observationsHistory'
              role='tabpanel'
              aria-labelledby='pills-observationsHistory-tab'
            >
              <div className='card mb-5 mb-xl-10'>
                <div className='card-header cursor-pointer'>
                  <div className='card-title m-0'>
                    <h3 className='fw-bolder m-0'>Informações de Anotações Internas</h3>
                  </div>
                </div>
                <div className='card-body py-3'>
                  {selectedTab === 'OBSERVATIONSHISTORY' && (
                    <ListObservationsHistory observations={person?.observations} />
                  )}
                </div>
              </div>
              {person?.activeAlert && (
                <div className='card mb-5 mb-xl-10'>
                  <div className='card-header cursor-pointer'>
                    <div className='card-title m-0'>
                      <h3 className='fw-bolder m-0'>Informações de Restrições</h3>
                    </div>
                  </div>
                  <div className='card-body py-3'>
                    {selectedTab === 'OBSERVATIONSHISTORY' && (
                      <ListObservationsHistory observations={person?.alerts} />
                    )}
                  </div>
                </div>
              )}
            </div>
            <div
              className='tab-pane fade p-4 pt-0 pt-md-4'
              id='pills-voucher'
              role='tabpanel'
              aria-labelledby='pills-voucher-tab'
            >
              <div className='card mb-5 mb-xl-10'>
                <div className='card-body py-3'>
                  {selectedTab === 'VOUCHER' && isAuthorizedToViewVoucher && <ListVoucher />}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {showEditPersonModal && person && (
        <PersonEditModal
          person={person}
          provider={useClientCart}
          index={0}
          close={() => setShowEditPersonModal(false)}
        />
      )}
    </>
  )
}

export const PeopleShowPage = () => {
  return (
    <>
      <PageTitle breadcrumbs={peopleBreadcrumbs}>Dados Pessoais</PageTitle>
      <PeopleProvider>
        <ContractProvider>
          <BillingProvider>
            <FranchiseTransferCardProvider>
              <RecurrentPaymentProvider>
                <PaymentConfigProvider>
                  <Show />
                </PaymentConfigProvider>
              </RecurrentPaymentProvider>
            </FranchiseTransferCardProvider>
          </BillingProvider>
        </ContractProvider>
      </PeopleProvider>
    </>
  )
}
